/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-southeast-2",
    "aws_appsync_graphqlEndpoint": "https://dr7wkjrg3bfcdemf6bq7a6vsky.appsync-api.ap-southeast-2.amazonaws.com/graphql",
    "aws_appsync_region": "ap-southeast-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-ghjayghwnvec3fajfhiib7vzgu",
    "aws_cloud_logic_custom": [
        {
            "name": "getKey",
            "endpoint": "https://wdfgynaaff.execute-api.ap-southeast-2.amazonaws.com/main",
            "region": "ap-southeast-2"
        }
    ],
    "aws_cognito_identity_pool_id": "ap-southeast-2:961caf4e-e25b-4644-b864-eae60f2ccc65",
    "aws_cognito_region": "ap-southeast-2",
    "aws_user_pools_id": "ap-southeast-2_Dldp7bGnf",
    "aws_user_pools_web_client_id": "30jo1qe3esnha9vt97qb12fod0",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "referral07e5e-main",
    "aws_user_files_s3_bucket_region": "ap-southeast-2"
};


export default awsmobile;
